// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsSnsTopicsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-sns-topics_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7.01 20.08a1.1 1.1 0 0 1 2.2 0c0 .6-.49 1.1-1.1 1.1a1.1 1.1 0 0 1-1.1-1.1M20.78 33C14.8 33 9.64 28.38 8.47 22.14a2.1 2.1 0 0 0 1.69-1.56h2.95v-1h-2.95a2.1 2.1 0 0 0-1.65-1.56A12.6 12.6 0 0 1 20.78 8q4.41 0 7.19 1.91l.58-.82Q25.5 7 20.78 7c-6.51 0-12.1 4.73-13.31 11.1A2.1 2.1 0 0 0 6 20.08c0 .91.6 1.69 1.43 1.97C8.6 28.89 14.23 34 20.78 34c3.28 0 6.78-1.67 8.78-3.1l-.59-.8c-2.02 1.44-5.34 2.9-8.2 2.9m-6-14.76c1.12.28 2.53.32 3.35.32.84 0 2.27-.04 3.4-.32l-2.4 5.02a1 1 0 0 0-.05.21v2.33l-1.95.91v-3.24a1 1 0 0 0-.05-.2zm3.35-1.75c2.32 0 3.56.3 3.95.52-.41.23-1.74.55-3.95.55-2.18 0-3.48-.32-3.87-.55.37-.21 1.58-.53 3.87-.53m-1.78 11.43a.5.5 0 0 0 .49.03l2.97-1.38a.5.5 0 0 0 .28-.46v-2.53L23 17.51a.8.8 0 0 0 .2-.51c0-1.25-2.76-1.52-5.07-1.52-2.26 0-4.97.27-4.97 1.52q0 .29.18.5l2.78 6.08v3.92q.01.27.23.42M30.88 27c.6 0 1.1.5 1.1 1.1s-.5 1.09-1.1 1.09-1.1-.5-1.1-1.1.49-1.09 1.1-1.09m0-16.03c.6 0 1.1.49 1.1 1.1a1.1 1.1 0 0 1-2.2 0c0-.61.49-1.1 1.1-1.1m1 8.01c.61 0 1.11.5 1.11 1.1s-.5 1.1-1.1 1.1-1.1-.5-1.1-1.1.49-1.1 1.1-1.1m-4.6 1.6h2.56a2.1 2.1 0 0 0 4.16-.5 2.1 2.1 0 0 0-4.16-.5h-2.56v-7.02h1.55a2.1 2.1 0 0 0 4.16-.5 2.1 2.1 0 0 0-4.16-.5h-2.06a.5.5 0 0 0-.5.5v7.52H23.2v1h3.06v7.51c0 .28.23.5.5.5h2.06a2.1 2.1 0 0 0 4.16-.5 2.1 2.1 0 0 0-4.16-.5h-1.55z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-sns-topics_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsSnsTopics",
);
export default AwsSnsTopicsIcon;
